"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _atoms = require("../../atoms");

var _intl = require("../../intl");

var _RateCardDefaultSettingInput = _interopRequireDefault(require("./organisms/RateCardDefaultSettingInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Body = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RateCardDefaultSettings__Body"
})(["padding:", ";"], function (_ref) {
  var spacing = _ref.theme.spacing;
  return (0, _styledComponents.css)(["", ""], spacing(2, 4));
});

var Footer = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "RateCardDefaultSettings__Footer"
})(["", ""], function (_ref2) {
  var _ref2$theme = _ref2.theme,
      palette = _ref2$theme.palette,
      spacing = _ref2$theme.spacing;
  return (0, _styledComponents.css)(["background-color:", ";padding:", ";"], palette.grey[50], spacing(2));
});

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RateCardDefaultSettings__Container"
})(["", ""], function (_ref3) {
  var palette = _ref3.theme.palette;
  return (0, _styledComponents.css)(["background-color:", ";"], palette.background.paper);
});

var Title = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "RateCardDefaultSettings__Title"
})(["display:block;margin-bottom:", ";"], function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return spacing(2);
});

var RateCardSettings = function RateCardSettings(_ref5) {
  var title = _ref5.title,
      type = _ref5.type,
      rate = _ref5.rate,
      rateMarkup = _ref5.rateMarkup,
      paymentDays = _ref5.paymentDays,
      currencySymbol = _ref5.currencySymbol,
      onSave = _ref5.onSave,
      markupInputProps = _ref5.markupInputProps,
      rateInputProps = _ref5.rateInputProps,
      paymentDaysInputProps = _ref5.paymentDaysInputProps,
      handleRateMarkupChangeOverride = _ref5.handleRateMarkupChangeOverride,
      props = _objectWithoutProperties(_ref5, ["title", "type", "rate", "rateMarkup", "paymentDays", "currencySymbol", "onSave", "markupInputProps", "rateInputProps", "paymentDaysInputProps", "handleRateMarkupChangeOverride"]);

  var _useState = (0, _react.useState)({
    rate: rate,
    rateMarkup: rateMarkup,
    paymentDays: paymentDays
  }),
      _useState2 = _slicedToArray(_useState, 2),
      settings = _useState2[0],
      setSettings = _useState2[1];

  var handleChange = (0, _react.useCallback)(function (newEntry) {
    setSettings(_objectSpread({}, settings, {}, newEntry));
  }, [settings, setSettings]);
  return _react["default"].createElement(Container, props, _react["default"].createElement(Body, null, _react["default"].createElement(Title, {
    variant: "caption",
    color: "primary"
  }, title), _react["default"].createElement(_core.Grid, {
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "flex-start",
    spacing: 6
  }, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 4
  }, _react["default"].createElement(_RateCardDefaultSettingInput["default"], {
    value: settings.rateMarkup,
    input: "rateMarkup",
    handleChange: handleChange,
    currencySymbol: currencySymbol,
    numberInputProps: markupInputProps,
    handleRateMarkupChangeOverride: handleRateMarkupChangeOverride
  })), type === 'client' && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 4
  }, _react["default"].createElement(_RateCardDefaultSettingInput["default"], {
    value: settings.rate,
    input: "rate",
    handleChange: handleChange,
    currencySymbol: currencySymbol,
    numberInputProps: rateInputProps
  })), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 4
  }, _react["default"].createElement(_RateCardDefaultSettingInput["default"], {
    value: settings.paymentDays,
    input: "paymentDays",
    handleChange: handleChange,
    numberInputProps: paymentDaysInputProps
  }))))), _react["default"].createElement(Footer, {
    container: true,
    direction: "row",
    justify: "flex-end",
    alignItems: "center"
  }, _react["default"].createElement(_core.Grid, {
    item: true
  }, _react["default"].createElement(_atoms.Button, {
    onClick: function onClick() {
      return onSave(settings);
    },
    size: "small",
    startIcon: _react["default"].createElement(_atoms.Icon, {
      icon: "check",
      size: "small",
      color: "inherit"
    })
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "common.form.save"
  })))));
};

RateCardSettings.propTypes = {
  title: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['global', 'client']).isRequired,
  rate: _propTypes["default"].number,
  rateMarkup: _propTypes["default"].number,
  paymentDays: _propTypes["default"].number,
  currencySymbol: _propTypes["default"].string.isRequired,
  onSave: _propTypes["default"].func.isRequired,
  markupInputProps: _propTypes["default"].object,
  rateInputProps: _propTypes["default"].object,
  paymentDaysInputProps: _propTypes["default"].object
};
RateCardSettings.defaultProps = {
  title: 'Default Settings',
  type: 'global',
  currencySymbol: '€',
  markupInputProps: {},
  rateInputProps: {},
  paymentDaysInputProps: {}
};
var _default = RateCardSettings;
exports["default"] = _default;